import { Route, Routes } from "react-router-dom";

import Layout from "./components/layout/Layout";
import NeedConnect from "./page/NeedConnect";
import NotFound from "./page/NotFound";

import { useSelector } from "react-redux";
import { account_info } from "reducer/account";
import {useEffect, useState} from "react";
import { addAccessTokenToHeader } from "server";
import Main from "./page/Main";
import History from "./page/History";
import Swap from "./page/Swap";

function RootRouter() {
  const account = useSelector(account_info);

  const [isAuth, setIsAuth] = useState<boolean>(false);

  useEffect(() => {
    if (account?.userInfo?.token?.access?.token) {
      addAccessTokenToHeader(account.userInfo.token.access.token);
      setIsAuth(true)
    }else {
      setIsAuth(false)
    }
  }, [account]);

  return (
    <Routes>
      <Route path={"*"} element={<Layout />}>
        {(!account.isConnect || !isAuth) && <Route path={'*'} element={<NeedConnect />} />}
        {account.isConnect && isAuth && <Route path={'*'} element={<Main />}>
          <Route path={'swap'} element={<Swap />} />
          <Route path={'history'} element={<History />} />
        </Route>}
        <Route path={"*"} element={<NotFound />} />
      </Route>
    </Routes>
  );
}

export default RootRouter;
